import { useMemo } from 'react';
import Box from '@rsos/components/capstone/base/Box';
import { VOIP, LANDLINE } from '@rsos/constants/locationTypes';
import { EstimatedAddress } from '../styles/common.styles';

const EstimatedAddressLabel = ({
  isMostRecent,
  singleHistoricLocation,
  classOfService,
  classOfServiceCategory,
  rgAddressProvider,
}) => {
  const addressLabel = useMemo(() => {
    if (classOfServiceCategory === VOIP) {
      return `• Provided Address from ANI/ALI (${classOfService})`;
    } else if (classOfServiceCategory === LANDLINE) {
      return '• Landline Address';
    } else if (!isMostRecent) {
      return `Estimated Address ${
        rgAddressProvider ? `from ${rgAddressProvider}` : ''
      } | VERIFY with caller`;
    } else {
      return null;
    }
  }, [classOfService, classOfServiceCategory, isMostRecent, rgAddressProvider]);

  if (!addressLabel) return null;

  return (
    <Box horizontal margin={singleHistoricLocation ? '0 16px' : '10px 0 0 0'}>
      <EstimatedAddress isMostRecent data-name="estimated-address">
        {addressLabel}
      </EstimatedAddress>
    </Box>
  );
};

export default EstimatedAddressLabel;
